
















































import { parseWebUrl, validURL } from '@/_utils/string-convert'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
@Component({
  components: {},
})
export default class BeaconCamera extends Vue {
  @Prop()
  urlCamera!: string

  ipAdrress: string = ''
  userName: string = ''
  userPassword: string = ''

  submited: boolean = false

  get propUrl(): string {
    return JSON.parse(JSON.stringify(this.urlCamera || ''))
  }

  set propUrl(value: string) {
    this.$emit('update:urlCamera', value)
  }

  mounted() {
    if (this.propUrl) {
      this.parseToModel()
    }
  }

  submit() {
    this.submited = true
    if (
      this.isIpAddressError ||
      this.isUserNameEmptyField ||
      this.isUserPassEmptyField
    ) {
      return false
    }

    this.propUrl = this.ipAdrress ? this.convertToData() : ''
    return true
  }

  get isIpAddressError() {
    if (this.submited) {
      const isEmptyAddress =
        (this.userPassword && !this.ipAdrress) ||
        (this.userName && !this.ipAdrress)
      const isInvalidAddress = this.ipAdrress && !validURL(this.ipAdrress)

      if (isEmptyAddress || isInvalidAddress) {
        return true
      }
    }
    return false
  }

  get isUserNameEmptyField() {
    return !this.userName && this.userPassword
  }

  get isUserPassEmptyField() {
    return !this.userPassword && this.userName
  }

  paste(event: ClipboardEvent) {
    // Get clipboard text
    let pasteText = event.clipboardData?.getData('text/plain') as string

    if (!pasteText.includes('http')) {
      pasteText = 'http://' + pasteText
    }

    if (!validURL(pasteText)) {
      return this.stopEmit(event)
    }

    this.parseToModel(pasteText)
    this.stopEmit(event)
  }

  convertToData() {
    const { protocol, host, port, path, query } = parseWebUrl(
      this.ipAdrress
    ) as any

    let cameraUrl = (protocol || 'http') + '://'
    if (this.userName && this.userPassword) {
      cameraUrl = cameraUrl + `${this.userName}:${this.userPassword}@`
    }

    cameraUrl = cameraUrl + host + (port || '') + (path || '') + (query || '')
    return cameraUrl
  }

  parseToModel(url?: string) {
    const urlToParse = url ? url : this.propUrl
    const { fullUrl, authority } = parseWebUrl(urlToParse) as any
    if (fullUrl) {
      this.ipAdrress = fullUrl.replace(/[^/]*@/, '')
    }

    if (authority) {
      const auth = authority.replace('@', '').split(':')
      this.userName = auth[0]
      this.userPassword = auth[1]
    } else {
      this.userName = ''
      this.userPassword = ''
    }
  }

  validateIP(ipCheck: string) {
    return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
      ipCheck
    )
  }

  stopEmit(event: any) {
    event.preventDefault()
    event.stopPropagation()
  }
}
